export default "__VITE_ASSET__B$d3OlxN__"